
/**
 * Function returns the new state based on the
 * given action.
 *
 * @param {object} state
 * @param {object} action
 */
const queryParams = ( state = {}, action ) => {
  switch ( action.type ) {
    default:
      return state
  }
}

export default queryParams
